import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/tenants/page.tsx");
